<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo18bg.svg" />

    <p id="tag01" class="textBase basicItem01 tagDefault">PATO</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">CARACOL</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">MOSCA</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">SAPITO</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">CANGREJO</p>
    <p id="tag06" class="textBase basicItem01 tagDefault">TORTUGA</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <h2 id="text01" class="textBase">
      ¿QUÉ ANIMALES PUEDEN VENIR A TOMAR AGUA DE ESTA LAGUNA?
    </h2>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 52px;
  top: 1px;
}
#tag01 {
  position: absolute;
  width: 170px;
  text-align: center;
  left: 27px;
  top: 428px;
}
#tag02 {
  position: absolute;
  width: 170px;
  text-align: center;
  left: 271px;
  top: 428px;
}
#tag03 {
  position: absolute;
  width: 170px;
  text-align: center;
  left: 521px;
  top: 428px;
}
#tag04 {
  position: absolute;
  width: 170px;
  text-align: center;
  left: 771px;
  top: 428px;
}
#tag05 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 271px;
  top: 507px;
}
#tag06 {
  position: absolute;
  width: 170px;
  text-align: center;
  left: 521px;
  top: 507px;
}

#text01 {
  position: absolute;
  font-size: 29px;
  left: 20px;
  top: 613px;
}
#inputField01 {
  position: absolute;
  width: 823px;
  height: 50px;
  left: 120px;
  top: 667px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 83.mp4",
        "glo/Video 84.mp4",
        "glo/Video 85.mp4",
        "glo/Video 86.mp4",
        "glo/Video 87.mp4",
        "glo/Video 88.mp4",
        "glo/Video 89.mp4",
      ],
    };
  },
};
</script>